export const resimoApiToken = "7GK4EPxhYHi0AMs0R1QHPGIzc";
export const resimoApiToken = "7GK4EPxhYHi0AMs0R1QHPGIzc";
